<template>
	<div id="ask" name="ask" class="col-lg-8">
		<div v-if="!authorizedThroughEsia">
			<div class="activity-list">
				<div class="activity-item text-block">

					<p>В соответствии с Федеральным законом от 28.12.2024 № 547-ФЗ «О внесении изменений в
						Федеральный закон «О порядке рассмотрения обращений граждан Российской Федерации»
						направление обращений граждан в форме электронного документа предусмотрено с использованием
						авторизации через Единую систему идентификации и аутентификации (ЕСИА).</p>

					<div class="content__block">
						<router-link class="content__block-title" to="/esia-login">
							Отправить обращение
						</router-link>
						<div class="content__block-text">Авторизации через ЕСИА</div>
					</div>

				</div>
			</div>
		</div>
		<div v-else>
			<div v-if="isSend">
				<div class="tile">
					<div v-if="disablingSendingText">
						Уважаемый {{ fio }}!
						<br>
						Исходящий номер Вашего обращения {{ uid }}
						<br>
						<br>
						<div v-html="disablingSendingText">
						</div>
						<br>
						Результат рассмотрения обращения Вы можете посмотреть
						<a href="https://reception.gorodperm.ru/check">здесь</a>.
						<br>
						<br>
						Пожалуйста, запомните регистрационный номер Вашего обращения и используйте в дальнейшем для
						просмотра результата рассмотрения.
					</div>
					<div v-else>
						УВАЖАЕМЫЙ(АЯ) <strong>{{ fio }}</strong>
						<br>
						Вы подали обращение в интернет приемную администрации города Перми.
						<br>
						Номер обращения: <strong>{{ uid }}</strong>.
						<br>
						Текущий статус обращения: <strong>Ожидает регистрацию</strong>.
						<br>
						<br>
						Текущий статус рассмотрения обращения Вы можете посмотреть на странице:
						<strong>
							<a href="https://reception.gorodperm.ru/check">https://reception.gorodperm.ru/check</a>
						</strong>
						<br>
						<br>
						Пожалуйста, запомните регистрационный номер Вашего обращения и используйте в дальнейшем для
						просмотра статусов рассмотрения обращения.
						<br>
						<br>
						В соответствии со ст. 8 Федерального закона от 2 мая 2006 г. № 59-ФЗ "О порядке рассмотрения
						обращений граждан Российской Федерации", Ваше обращение будет зарегистрировано в течение трех
						дней.
					</div>
					<div>
						<button @click="isSend = false" class="btn blue" type="submit" id="submit_ask"
							name="submit_ask">
							Отправить новое
						</button>
					</div>
				</div>
			</div>
			<form v-if="!isSend" action="" method="post" name="ask" enctype="multipart/form-data">
				<div class="tile" v-show="errors.find(x => x === 'server-error')">
					{{ message }}
				</div>

				<div class="tile">
					<div class="form-group">
						<div class="info2" style="margin-top: 1px;">
							Данная форма является официальным обращением в администрацию города Перми и влечет правовые
							последствия, которые предусмотрены Федеральным законом Российской Федерации от 2 мая 2006 г.
							N
							59-ФЗ
							"О порядке рассмотрения обращений граждан Российской Федерации".
							<br>
							Для отправки обращения необходимо корректно заполнить все поля, отмеченные *.
						</div>

						<div v-show="errors.find(x => x === 'local_government')" id="noogv" style="color: #fc0700;">
							<strong>
								Не выбран орган местного самоуправления
							</strong>
						</div>
						<div class="text required">
							<label class="text required" for="input-1">
								Орган местного самоуправления, на территории которого Вы проживаете
							</label>
						</div>
						<div class="input-field">
							<select v-model="local_government" name="omsu" id="local_government"
								title="Орган местного самоуправления" required>
								<option disabled="disabled" value="">
									Выбрать из списка
								</option>
								<option v-for="item in local_governments" :value="item.id" :key="item.id">
									{{ item.name }}
								</option>
							</select>
						</div>
					</div>
				</div>

				<div class="tile">
					<div class="form-group">
						<div class="text required">
							<label class="text required" for="zone">
								Выберите адресата
							</label>
							<span v-show="errors.find(x => x === 'zone')" id="noaddressat" style="color: #fb1203;">
								<strong>
									Не выбран адресат
								</strong>
							</span>
						</div>
						<div class="input-field">
							<ModelSelect ref="zones-select" :options="zones" v-model="zone"
								placeholder="Выбрать из списка" id="zone">
							</ModelSelect>
						</div>
					</div>

					<div class="form-group">
						<div class="text required">
							<label class="text required" for="input-4">
								Тема
							</label>
						</div>
						<span v-show="errors.find(x => x === 'theme')" id="notheme" style="color: #fc0700;">
							<strong>
								Отсутствует тема обращения
							</strong>
						</span>
						<div class="info" style="margin-top: 1px;">
							Пожалуйста, кратко обозначьте вопрос.
						</div>
						<div class="input-field">
							<input v-model="theme" id="theme" class="text-input"
								title="Кратко, содержание Вашего обращения" type="text" name="theme">
						</div>
					</div>

					<div class="form-group">
						<div class="text required">
							<label class="text required" for="topic">
								Текст обращения
							</label>
							<span v-show="errors.find(x => x === 'topic')" id="notext" style="color: #fe1000;">
								<strong>
									Отсутствует текст обращения
								</strong>
							</span>
						</div>
						<div class="info2" style="margin-top: 1px;">
							В соответствии с частью 1 статьи 7 Федерального закона от 2 мая 2006 года № 59-ФЗ «О порядке
							рассмотрения обращений граждан Российской Федерации» гражданин в своём обращении в
							обязательном
							порядке излагает <strong>суть предложения, заявления или жалобы</strong>.<br> В целях
							объективного и
							всестороннего рассмотрения Вашего обращения в установленные сроки
							<strong>необходимо</strong> в
							тексте обращения указывать адрес описанного Вами места действия, факта или события, а также
							<strong>можно</strong> указать телефон для возможного уточнения содержания Вашего обращения.
						</div>
						<div class="input-field">
							<textarea v-model="topic" id="topic" name="topic" rows="5"></textarea>
						</div>
					</div>

					<div class="checkbox">
						<input v-model="mp" id="mp" type="checkbox" name="mp">
						<label for="mp">
							Коллективное обращение
						</label>
					</div>
					<div v-show="mp" class="info2" id="manypeoples">
						<strong>
							Внимание!
						</strong>
						<br>
						Для отправки коллективного обращения Вы должны приложить файл, содержащий список соавторов
						<span v-show="errors.find(x => x === 'mp-file')" id="mp-file" style="color: #fe1000;">
							<strong>
								Отсутствует файл, содержащий список соавторов
							</strong>
						</span>
					</div>

					<div class="form-group">
						<div class="form__title-file active" @click="addFile">Прикрепить файлы</div>
						<div class="form__input-files">
							<div class="form__input-file" v-for="(item, index) in files" :key="index">
								<div class="qwer"></div>
								<input type="text" class="form__input-files-text" disabled :value="item.name">
								<div class="form__btns">
									<input type="file" name="userfile[]" :id="`file` + index"
										@change="(e) => selectFile(e.target.files[0], index)"
										class="form__input-file-elem">
									<label :for="`file` + index" class="form__label-file btn blue">Выбрать</label>
									<div class="btn blue form__btn form__btn-close" @click="() => deleteFile(index)">
									</div>
									<div class="btn blue form__btn form__btn-add" @click="addFile"></div>
								</div>
							</div>
						</div>
					</div>

					<div class="info2">
						В соответствии с частью 2 статьи 7 Федерального закона от 2 мая 2006 года № 59-ФЗ «О порядке
						рассмотрения обращений граждан Российской Федерации» в случае необходимости в подтверждение
						своих
						доводов гражданин прилагает к письменному обращению документы и материалы либо их копии. В связи
						с
						чем,Вы вправе приложить к обращению необходимые документы и материалы в электронной форме,
						воспользовавшись функцией «Прикрепить файл». Обращаем внимание, что прикрепляемые в предложенном
						на
						сайте формате документы и материалы служат лишь подтверждением доводов автора обращения,
						изложенных
						в
						тексте обращения.
						<br>
						Приложить необходимые документы и материалы в электронной форме можно в любой
						последовательности:
						вложениями файла без архивирования (файл вложения) по одному из двух разных типов допустимых
						форматов.
						Допустимые форматы:
						<ul style="margin-top:5px;margin-bottom:5px">
							<li>
								текстового (графического) формата: txt, doc, docx, rtf, xls, xlsx, pps, ppt, odt, ods,
								odp,
								pub,
								pdf, jpg, jpeg, bmp, png, tif, gif, pcx;
							</li>
							<li>
								аудио- (видео-) формата: mp3, wma, avi, mp4, mkv, wmv, mov, flv.
							</li>
						</ul>
						Иные форматы не обрабатываются в информационных системах органов государственной власти и
						органов
						местного самоуправления Пермского края.
						При подключении оборудования пользователя к сети «Интернет» по выделенным каналам связи с
						использованием
						технологий ADSL, 3G, 4G, WiFi и иных технологий, обеспечивающих аналогичные скорости передачи
						данных
						в
						сети «Интернет», передача и обработка файла(ов) с суммарным размером:
						<ul style="margin-top:5px;margin-bottom:5px">
							<li>
								до 5 Мб осуществляется, как правило, без задержки во времени;
							</li>
							<li>
								от 5 Мб до 10 Мб может осуществляться с задержкой во времени;
							</li>
							<li>
								свыше 10 Мб может быть не осуществлена.
							</li>
						</ul>
					</div>
				</div>


				<div class="tile">
					<div class="form-group row">
						<div class="text required col-sm-4">
							<label class="text required" for="name">
								Фамилия, имя, отчество в именительном падеже
							</label>
							<div class="info2" style="margin-top: 1px;">
								В соответствии с частью 1 статьи 7 Федерального закона от 2 мая 2006 года № 59-ФЗ «О
								порядке
								рассмотрения обращений граждан Российской Федерации» гражданин в своем письменном
								обращении
								в
								обязательном порядке указывает свои фамилию, имя, отчество (последнее - при наличии)
							</div>
						</div>
						<div class="input-group col-sm-8">
							<div class="input-field">
								<input v-model="name" id="name" class="text-input" title="Ваша фамилия" type="text"
									name="name" placeholder="Фамилия" required disabled>
							</div>
							<span v-show="errors.find(x => x === 'name')" id="noname"
								style=" font-weight: bold; color: #fc1602;">
								Отсутствует фамилия
								<em class="red">
									<br>
								</em>
							</span>
							<div class="input-field">
								<input v-model="firstname" id="firstname" class="text-input" title="Ваше имя"
									type="text" name="firstname" placeholder="Имя" required disabled>
							</div>
							<span v-show="errors.find(x => x === 'firstname')" id="noforname"
								style=" font-weight: bold; color: #fa1704;">
								Отсутствует имя
								<em class="red" style="font-weight: bold; font-variant: normal; color: #fe0a00;">
									<br>
								</em>
							</span>
							<div v-show="!snchk" class="input-field if-there-is">
								<input v-model="secondname" id="secondname" type="text" name="secondname"
									placeholder="Отчество" disabled>
							</div>
							<br>
							<div class="checkbox">
								<input v-model="snchk" id="snchk" type="checkbox" name="snchk">
								<label for="snchk">
									Отчество отсутствует
								</label>
							</div>
						</div>
					</div>
				</div>

				<div class="tile">
					<div class="form-group row">
						<div class="text required col-md-4">
							<label for="input-77">
								Ответ прошу направить
							</label>
						</div>
						<div class="input-group col-md-8">
							<div class="input-field">
								<div class="radio">
									<input v-model="answer_type" type="radio" name="post" id="input-77"
										checked="checked" data-toggle="#option-1">
									<label for="input-77">
										Электронный адрес
									</label>
								</div>
							</div>
						</div>
					</div>
					<div class="optional" id="option-1">
						<div class="form-group row">
							<div class="text required col-md-4">
								<label class="text required" for="input-30">
									Укажите e-mail
								</label>
								<span v-show="errors.find(x => x === 'emailvalue')" id="noemail"
									style=" color: #fe1000;">
									<br>
									<strong>
										Отсутствует адрес электронной почты
									</strong>
								</span>
								<span id="wrong-email" style=" color: #fd0b01;" tabindex="-1">
									<strong v-show="errors.find(x => x === 'wrong-email')">
										Адрес электронной почты некорректный.
									</strong>
								</span>
							</div>
							<div class="input-group col-md-8">
								<div class="input-field">
									<input v-model="emailvalue" id="emailvalue" class="text-input"
										title="Адрес Вашей электронной почты" type="email" name="emailvalue" required
										:readonly="emailvalue_ro">
								</div>
							</div>
						</div>
						<div class="form-group row">
							<div class="text required col-md-4">
								<label class="text required" for="input-33">
									Повторите e-mail
								</label>
								<span v-show="errors.find(x => x === 'emailvaluer')" id="noemail2"
									style=" color: #fe1000;">
									<br>
									<strong>
										Отсутствует адрес электронной почты
									</strong>
								</span>
							</div>
							<div class="input-group col-md-8">
								<div class="input-field">
									<input v-model="emailvaluer" id="emailvaluer" class="text-input"
										title="Повторите Ваш Адрес электронной почты" type="text" name="emailvaluer"
										required :readonly="emailvalue_ro">
								</div>
								<span v-show="errors.find(x => x === 'different-emails')" id="different-emails"
									style=" color: #fd0b01;" tabindex="-1">
									<strong>
										Адрес электронной почты и его подтверждение не совпадают. Пожалуйста, проверьте
										правильность заполнения обоих полей.
									</strong>
								</span>
							</div>
						</div>
					</div>
					<div class="form-group row">
						<div class="text required col-md-4">
							<label for="input-34">
								Контактный телефон
							</label>
						</div>
						<div class="input-group col-md-8">
							<div class="input-field">
								<input v-model="telNo" id="telNo" class="phone-number" name="phone" type="tel"
									maxlength="18">
							</div>
						</div>
					</div>
					<div class="info">
						Информация о персональных данных авторов обращений, направленных в форме электронного документа,
						хранится и обрабатывается с соблюдением требований российского законодательства о персональных
						данных.
					</div>
				</div>

				<div class="tile">
					<div class="form-group">
						<div class="info2">
							В случае обращения от имени юридического лица, заполните дополнительно:
						</div>
						<div>
							<label class="text" for="input-4">
								Должность:
							</label>
						</div>
						<div class="input-field">
							<input v-model="position" id="position" class="text-input" title="Должность" type="text"
								name="position">
						</div>
						<div>
							<label class="text" for="input-4">
								Наименование юридического лица:
							</label>
						</div>
						<div class="input-field">
							<input v-model="company" id="company" class="text-input"
								title="Наименование юридического лица" type="text" name="company">
						</div>
					</div>
				</div>

				<div class="tile">
					<div class="input-field">
						<div class="checkbox" id="consentDiv">
							<input v-model="consent" id="consent" type="checkbox" name="consent" required>
							<label for="consent">
								Я даю согласие на использование в качестве каналов передачи
								информации, содержащейся в обращении, открытых каналов связи
								Интернет
							</label>
							<span v-show="errors.find(x => x === 'consent')" id="no432" style=" color: #fd0b01;">
								<strong>
									Вы не отметили флажок.
								</strong>
							</span>
						</div>
					</div>
					<div class="input-field">
						<div class="checkbox" id='haveReadDiv'>
							<input v-model="haveRead" id="haveRead" type="checkbox" name="haveRead" required>
							<label for="haveRead">
								Ознакомлен с
								<a href="https:\\www.gorodperm.ru/upload/pages/4881/rasporazhenije_194-r.docx"
									target="_blank">
									Положением об обработке и организации защиты персональных данных в администрации
									города
									Перми
								</a>
								и
								<a href="https://www.gorodperm.ru/upload/pages/35/2020/Prilozhenije_1_Dla_razmeshhenija.docx"
									target="_blank">
									Регламентом работы по рассмотрению обращений граждан в администрации города Перми и
									о
									признании утратившими силу отдельных постановлений администрации города Перми,
									утвержденным
									постановлением администрации города Перми от 18.06.2021 №451
								</a>
							</label>
							<span v-show="errors.find(x => x === 'haveRead')" id="no456" style=" color: #fd0b01;">
								<strong>
									Вы не отметили флажок.
								</strong>
							</span>
						</div>
					</div>

					<div class="info2" style="margin-top: 1px;">
						Информация о персональных данных авторов обращений,направленных в форме электронного документа,
						хранится
						и обрабатывается с соблюдением требований российского законодательства о персональных данных.
						<br>
						В соответствии с Федеральным законом от 2 мая 2006 г. № 59-ФЗ «О порядке рассмотрения обращений
						граждан
						Российской Федерации» ответ на обращение не дается в случаях если:
						<br>
						- в обращении не указаны фамилия обратившегося или электронный адрес для ответа;
						<br>
						- в обращении содержатся нецензурные либо оскорбительные выражения, высказывания, содержащие
						угрозы
						жизни, здоровью и имуществу должностного лица, а также членов его семьи;
						<br>
						- в обращении гражданина содержится вопрос, по которому ему неоднократно давались письменные
						ответы
						по
						существу в связи с ранее направленными обращениями, и при этом в обращении не приводятся новые
						доводы
						или обстоятельства, при условии, что указанное обращение и ранее направленные обращения были
						адресованы
						в один и тот же государственный орган или одному и тому же должностному лицу и переписка по
						этому
						вопросу прекращена;
						<br>
						- по вопросам, содержащимся в обращении, имеется вступившее в законную силу судебное решение.
						Согласно
						Конституции Российской Федерации, правосудие в России осуществляется только судом. Органы
						судебной
						власти самостоятельны и действуют независимо от законодательной и исполнительной власти. Решения
						судебных органов обжалуются в установленном законом процессуальном порядке. Действующее
						законодательство
						запрещает всякое вмешательство в процесс отправления правосудия; текст обращения не поддается
						прочтению;
						<br>
						- ответ по существу поставленного в обращении вопроса не может быть дан без разглашения
						сведений,
						составляющих государственную или иную охраняемую законом тайну.
						<br>
						Обработка персональных данных, необходимых в связи с рассмотрением обращений граждан,
						осуществляется
						без
						согласия субъектов персональных данных в соответствии с пунктом 2 части 1 статьи 6 Федерального
						закона
						"О персональных данных" и Федеральным законом "О порядке рассмотрения обращений граждан
						Российской
						Федерации".
						Передача (распространение, предоставление) и использование персональных данных, необходимых в
						связи
						с
						рассмотрением обращений граждан, осуществляется лишь в случаях и в порядке, предусмотренных
						законодательством Российской Федерации.
					</div>
					<div class="info">
						<strong>
							Внимание!
						</strong>
						<br>
						Повторная отправка обращений существенно замедляет процесс обработки и рассмотрения обращения.
						Во
						избежание повторной отправки обращений, убедительная просьба перед отправкой проверить
						правильность
						заполнения всех полей
					</div>

					<div class="controls" style="margin-top: 30px;">
						<button @click="save" :class="`button ${isSending ? 'button--disabled' : ''}`" type="submit"
							id="submit_ask" name="submit_ask" :disabled="isSending">
							Сохранить
						</button>
						<div v-if="isSending">
							<strong>Выполняется отправка...</strong>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import { ModelSelect } from "vue-search-select";
import validateEmail from '@/functions/validateEmail';
import { getData, getDataJson } from '@/api/getData';
import { authorized, getAccessToken, getConfig, getUserRole, getFields, authorizedThroughEsia } from '@/auth';
import { post } from '@/api/saveData';

export default {
	components: {
		ModelSelect,
	},
	data() {
		return {
			authorizedThroughEsia: false,
			errors: [],
			local_government: '',
			local_governments: [],

			zone: '',
			zones: [],

			theme: '',

			topic: '',

			mp: false,
			files: [],

			fio: '',
			name: '',
			firstname: '',
			secondname: '',
			snchk: false,

			answer_type: 'email',
			answer_types: [{ value: 'email', label: 'Электронный адрес' },],
			emailvalue: '',
			emailvaluer: '',
			emailvalue_ro: false,
			telNo: '+7',

			position: '',
			company: '',

			consent: false,
			haveRead: false,

			isCheck: false,

			isSend: false,
			isSending: false,

			uid: -1,
			success: null,

			urlPDF: getConfig().appealsUrl,
			role: getUserRole(),
			message: '',

			code: 'notification-about-disabling-sending',
			disablingSendingText: null,
		};
		//})
	},
	created() {
		this.authorizedThroughEsia = authorizedThroughEsia();
		getData({ zones: 'filter[available_to_citizens]=1' }).then(x => {
			let { local_governments, zones, } = x;

			this.local_governments = local_governments;
			this.local_government = local_governments?.[0]?.id;
			this.zones = zones.map(x => ({ ...x, value: x.id, text: x.name }));
		});

		const userField = getFields();
		this.firstname = userField?.given_name ?? '';
		//this.firstname_ro = Boolean(userField?.given_name);
		this.name = userField?.family_name ?? '';
		//this.name_ro = Boolean(userField?.family_name);
		this.secondname = userField?.middle_name ?? '';
		//this.secondname_ro = Boolean(userField?.middle_name);
		this.emailvalue = userField?.email ?? '';
		this.emailvaluer = userField?.email ?? '';
		//this.emailvalue_ro = Boolean(userField?.email);

		let apiPages = getConfig().apiPages;
		getDataJson(`${apiPages}?code=${this.code}`)
			.then(x => {
				if (x.success !== false) {
					this.disablingSendingText = x.html;
				}
			})
			.catch(x => {
				console.error(x);
			});
	},
	methods: {
		save: async function (e) {

			this.isSending = true;

			try {

				this.errors = [];
				let top = null;
				this.isCheck = true;

				let required = [
					{ field: 'local_government', value: '' },
					{ field: 'zone', value: '' },
					{ field: 'theme', value: '' },
					{ field: 'topic', value: '' },
					{ field: 'name', value: '' },
					{ field: 'firstname', value: '' },
					{ field: 'emailvalue', value: '' },
					{ field: 'emailvaluer', value: '' },
					{ field: 'consent', value: false, id: 'consentDiv' },
					{ field: 'haveRead', value: false, id: 'haveReadDiv' },
				];

				required.forEach(x => {
					if (!this[x.field] || this[x.field] === x.value) {
						this.errors.push(x.field);
						if (top === null) top = document.getElementById(x.id ?? x.field);
					}

					if (x.field === 'emailvalue') {
						if (validateEmail(this.emailvalue) === null) {
							this.errors.push('wrong-email');
							if (top === null) top = document.getElementById('emailvalue');
						}

						if (this.emailvaluer !== this.emailvalue) {
							this.errors.push('different-emails');
							if (top === null) top = document.getElementById('emailvalue');
						}
					}
				});

				if (this.mp && this.files.length === 0) {
					this.errors.push('mp-file');
					if (top === null) top = document.getElementById('mp-file');
				}

				if (this.errors.length > 0) {
					top.scrollIntoView({ block: 'center' });
					e.preventDefault();
				} else {
					e.preventDefault();
					let local_government = this.local_government;
					let zone = this.zone;
					let theme = this.theme;
					let topic = this.topic;
					let mp = this.mp;
					let files = this.files;
					let emailvalue = this.emailvalue;
					let telNo = this.telNo;
					let position = this.position;
					let company = this.company;

					let formData = new FormData();
					for (let i = 0; i < files.length; i++) {
						if (files[i].name) formData.append("files[]", files[i]);
					}
					// formData.append("last_name", name);
					// formData.append("first_name", firstname);
					// formData.append("middle_name", secondname);
					formData.append("theme", theme);
					formData.append("topic", topic);
					formData.append("is_collective", mp ? '1' : '0');
					formData.append("email", emailvalue);
					formData.append("phone_number", telNo);
					formData.append("position", position);
					formData.append("company", company);
					formData.append("zone_id", zone);
					formData.append("local_government_id", local_government);

					let isAuth = authorized();
					let url = isAuth
						? getConfig().appealsSaveUserUrl
						: getConfig().appealsSaveUrl;

					let headers = isAuth
						? { 'Authorization': 'Bearer ' + getAccessToken(), }
						: {};

					await post(url, formData, headers)
						.then(x => {
							this.success = x.success;
							this.uid = x?.data?.uid ?? '';

							if (this.uid !== '') {
								this.isSend = true;
								document.body.scrollTop = 0;
								document.documentElement.scrollTop = 0;
								this.fio = `${x.data.last_name ?? ''} ${x.data.first_name ?? ''} ${x.data.middle_name ?? ''}`;
								this.local_government = '';
								this.zone = '';
								this.theme = '';
								this.topic = '';
								this.mp = '';
								this.files = [];
								this.emailvalue = '';
								this.emailvaluer = '';
								this.telNo = '';
								this.position = '';
								this.company = '';
								this.consent = false;
								this.haveRead = false;
							}
							if (x.success === false) {
								this.errors.push(x.name);
								this.message = x.message;

								document.body.scrollTop = 0;
								document.documentElement.scrollTop = 0;
							}
						});
				}

				this.isSending = false;
			} catch (error) {
				console.error(error);
				this.isSending = false;
			}
		},

		addFile: function () {
			this.files.push({});
		},
		selectFile: function (file, index) {
			this.files[index] = file;
		},
		deleteFile: function (index) {
			this.files.splice(index, 1);
		}
	}
};
</script>